<app-side-menu></app-side-menu>
<div class="header">
    <div class="logo">
        <h4 class="text"><img alt="" class="dashboard-img" src="../../assets/images/dash-icon.png"> Template </h4>
    </div>

    <div class="toggle-icon">
        <img alt="" src="../../assets/images/user.png" (click)="usericonDialog();" style="width: 25px">
    </div>

</div>

<mat-drawer-container class="drawercontainer">
    <div class="main-page-wrapper">
        <div class="main-content-area" [ngClass]="{ 'disabled-form': loadingData }">
            <form class="example-form" >
                <div class="search-block d-flex align-items-center mb-2">
                    <div class="toggle-icon">
                        <button class="btn btn-theme me-3" (click)="addtemplate($event,'add');"  routerLink="/create-template"><i
                                class="fa fa-plus"></i></button>
                    </div>
                    <mat-form-field appearance="outline" class="template-input">
                        <input matInput placeholder="Search" [ngModelOptions]="{ standalone: true }" [(ngModel)]="userSearch"  (input)="applyFilter(userSearch)" />
                        <img alt="" src="../../assets/images/Icons_Search.svg" class="icon-search" />
                    </mat-form-field>

                       <div class="form-field-wrapper">
                      <mat-form-field class="serchbox  channel-field template-sort-value" appearance="fill">
                        <mat-label>Sort</mat-label>
                        <mat-select  [ngModelOptions]="{ standalone: true }" [(ngModel)]="SortVal" (selectionChange)="Sort(SortVal)">
                          <mat-option value="first">First to Last</mat-option>
                          <mat-option value="last">Last to First</mat-option>
  
                        </mat-select>
                      </mat-form-field>

  
  
                  </div>
                  <div class="ms-3">

                    <mat-form-field class="channel-field select-channel" appearance="fill">
                      <mat-label>Select Channel</mat-label>
                      <mat-select [ngModelOptions]="{ standalone: true }" [(ngModel)]="channelval" (selectionChange)="Gettemplates($event)">
                          <mat-option *ngFor="let Channel of Channels" [value]="Channel?.value" (click)="Clicktemplate(Channel?.name)">{{Channel?.name}}</mat-option>
                          
                      </mat-select>
                  </mat-form-field>
                  </div>
                  <div class="btn-bg-box">
                    <button (click)="Reset()" class="btn btn-cancle">Reset</button>
                
                
                
                  </div>
                </div>

             

            </form>

            <div class="data-table">
                <table  matSort mat-table summary="table" [dataSource]="dataSource" matSort class="mat-elevation-z8 mat-table">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                          <div class="status">
                            TEMPLATE NAME 
                   
                        </div>
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">
                          <div class="view-status">
                       <span class="element-name">
                        {{ element?.name }}
                       </span>
                            <div>

                         <svg (click)="Edittemplate(element,'view');"  fill="#0396a6" width="40" height="24" viewBox="0 0 64 64" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         xml:space="preserve" xmlns:serif="http://www.serif.com/"
                         style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">

                         <rect id="Icons" x="-896" y="-256" width="1280" height="800" style="fill:none;" />

                         <g id="Icons1" serif:id="Icons">

                             <g id="Strike">

                             </g>

                             <g id="H1">

                             </g>

                             <g id="H2">

                             </g>

                             <g id="H3">

                             </g>

                             <g id="list-ul">

                             </g>

                             <g id="hamburger-1">

                             </g>

                             <g id="hamburger-2">

                             </g>

                             <g id="list-ol">

                             </g>

                             <g id="list-task">

                             </g>

                             <g id="trash">

                             </g>

                             <g id="vertical-menu">

                             </g>

                             <g id="horizontal-menu">

                             </g>

                             <g id="sidebar-2">

                             </g>

                             <g id="Pen">

                             </g>

                             <g id="Pen1" serif:id="Pen">

                             </g>

                             <g id="clock">

                             </g>

                             <g id="external-link">

                             </g>

                             <g id="hr">

                             </g>

                             <g id="info">

                             </g>

                             <g id="warning">

                             </g>

                             <g id="plus-circle">

                             </g>

                             <g id="minus-circle">

                             </g>

                             <g id="vue">

                             </g>

                             <g id="cog">

                             </g>

                             <g id="logo">

                             </g>

                             <g id="radio-check">

                             </g>

                             <g id="eye-slash">

                             </g>

                             <g id="eye">

                                 <path
                                     d="M32.513,13.926c10.574,0.15 19.141,9.894 23.487,18.074c0,0 -1.422,2.892 -2.856,4.895c-0.694,0.969 -1.424,1.913 -2.191,2.826c-0.547,0.65 -1.112,1.283 -1.698,1.898c-5.237,5.5 -12.758,9.603 -20.7,8.01c-8.823,-1.77 -15.732,-9.498 -20.058,-17.629c0,0 1.248,-2.964 2.69,-4.964c0.646,-0.897 1.324,-1.77 2.034,-2.617c0.544,-0.649 1.108,-1.282 1.691,-1.897c4.627,-4.876 10.564,-8.63 17.601,-8.596Zm-0.037,4c-5.89,-0.022 -10.788,3.267 -14.663,7.35c-0.527,0.555 -1.035,1.127 -1.527,1.713c-0.647,0.772 -1.265,1.569 -1.854,2.386c-0.544,0.755 -1.057,1.805 -1.451,2.59c3.773,6.468 9.286,12.323 16.361,13.742c6.563,1.317 12.688,-2.301 17.016,-6.846c0.529,-0.555 1.04,-1.128 1.534,-1.715c0.7,-0.833 1.366,-1.694 1.999,-2.579c0.557,-0.778 1.144,-1.767 1.588,-2.567c-3.943,-6.657 -10.651,-13.944 -19.003,-14.074Z" />

                                 <path
                                     d="M32.158,23.948c4.425,0 8.018,3.593 8.018,8.017c0,4.425 -3.593,8.017 -8.018,8.017c-4.424,0 -8.017,-3.592 -8.017,-8.017c0,-4.424 3.593,-8.017 8.017,-8.017Zm0,4.009c2.213,0 4.009,1.796 4.009,4.008c0,2.213 -1.796,4.009 -4.009,4.009c-2.212,0 -4.008,-1.796 -4.008,-4.009c0,-2.212 1.796,-4.008 4.008,-4.008Z" />

                             </g>

                             <g id="toggle-off">

                             </g>

                             <g id="shredder">

                             </g>

                             <g id="spinner--loading--dots-" serif:id="spinner [loading, dots]">

                             </g>

                             <g id="react">

                             </g>

                             <g id="check-selected">

                             </g>

                             <g id="turn-off">

                             </g>

                             <g id="code-block">

                             </g>

                             <g id="user">

                             </g>

                             <g id="coffee-bean">

                             </g>

                             <g id="coffee-beans">

                                 <g id="coffee-bean1" serif:id="coffee-bean">

                                 </g>

                             </g>

                             <g id="coffee-bean-filled">

                             </g>

                             <g id="coffee-beans-filled">

                                 <g id="coffee-bean2" serif:id="coffee-bean">

                                 </g>

                             </g>

                             <g id="clipboard">

                             </g>

                             <g id="clipboard-paste">

                             </g>

                             <g id="clipboard-copy">

                             </g>

                             <g id="Layer1">

                             </g>

                         </g>

                     </svg>

                     <ng-container *ngIf="element.isActive == true">
                         <svg class="circle-active" fill="green" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m0 12c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12c-6.624-.008-11.992-5.376-12-11.999zm2.4 0c0 5.302 4.298 9.6 9.6 9.6s9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6c-5.299.006-9.594 4.301-9.6 9.599v.001zm4 0c0-3.093 2.507-5.6 5.6-5.6s5.6 2.507 5.6 5.6-2.507 5.6-5.6 5.6c-3.093 0-5.6-2.507-5.6-5.6z"></path></g></svg>
                     </ng-container>
                     <ng-container *ngIf="element.isActive == false">
                         <svg class="circle-active" fill="red" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m0 12c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12c-6.624-.008-11.992-5.376-12-11.999zm2.4 0c0 5.302 4.298 9.6 9.6 9.6s9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6c-5.299.006-9.594 4.301-9.6 9.599v.001zm4 0c0-3.093 2.507-5.6 5.6-5.6s5.6 2.507 5.6 5.6-2.507 5.6-5.6 5.6c-3.093 0-5.6-2.507-5.6-5.6z"></path></g></svg>
                     </ng-container>
                    </div>
                  </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                          TEMPLATE TYPE
                        </th>
                        <td mat-cell *matCellDef="let element" class=" text-center" style="min-width: 85px; padding-right: 50px; ">
                          <!-- {{ element.type }}  -->
                        <span class="inbox" *ngIf="element.type == 4"><i class="fa fa-envelope-o  icon-box " aria-hidden="true"></i></span>
                          
                        <span class="sms" *ngIf="element.type == 1">
                          <svg fill="var(--black-color)" height="15px" width="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                          viewBox="0 0 455 455" xml:space="preserve">
                       <g>
                         <path d="M263.356,286.243c-4.143,0-7.5,3.358-7.5,7.5v75.572H66.644v-189.22h57.74c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5
                           h-57.74v-31.768c0-13.188,10.729-23.917,23.918-23.917h10.799c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H90.562
                           c-21.459,0-38.918,17.458-38.918,38.917v282.755c0,21.459,17.459,38.917,38.918,38.917h141.377
                           c21.459,0,38.918-17.458,38.918-38.917V293.743C270.856,289.601,267.499,286.243,263.356,286.243z M231.938,440H90.562
                           c-13.188,0-23.918-10.729-23.918-23.917v-31.768h189.213v31.768C255.856,429.271,245.127,440,231.938,440z"/>
                         <path d="M195.566,105.324c-10.906-1.784-11.366-2.85-11.366-5.089c0-3.959,6.645-5.005,10.158-5.005
                           c5.645,0,9.286,1.902,9.967,3.781c1.411,3.894,5.712,5.909,9.606,4.496c3.895-1.411,5.908-5.712,4.497-9.606
                           c-3.056-8.433-12.279-13.671-24.07-13.671c-14.813,0-25.158,8.226-25.158,20.005c0,15.976,14.989,18.428,23.944,19.893
                           c10.913,1.785,11.373,2.853,11.373,5.098c0,3.959-6.646,5.005-10.159,5.005c-5.645,0-9.287-1.903-9.967-3.783
                           c-1.409-3.896-5.712-5.908-9.604-4.501c-3.895,1.409-5.91,5.709-4.501,9.604c3.053,8.438,12.276,13.68,24.072,13.68
                           c14.813,0,25.159-8.226,25.159-20.005C219.518,109.242,204.524,106.789,195.566,105.324z"/>
                         <path d="M333.562,105.324c-10.906-1.784-11.366-2.85-11.366-5.089c0-3.959,6.645-5.005,10.158-5.005
                           c5.644,0,9.286,1.903,9.968,3.782c1.411,3.894,5.711,5.91,9.606,4.495c3.895-1.412,5.907-5.713,4.495-9.607
                           c-3.057-8.432-12.279-13.67-24.069-13.67c-14.813,0-25.158,8.226-25.158,20.005c0,15.976,14.989,18.428,23.944,19.893
                           c10.913,1.785,11.373,2.853,11.373,5.098c0,3.959-6.646,5.005-10.159,5.005c-5.646,0-9.288-1.904-9.969-3.784
                           c-1.409-3.894-5.707-5.912-9.604-4.5c-3.895,1.41-5.909,5.71-4.499,9.605c3.054,8.438,12.277,13.679,24.072,13.679
                           c14.813,0,25.159-8.226,25.159-20.005C357.513,109.242,342.52,106.789,333.562,105.324z"/>
                         <path d="M287.29,80.693c-2.949-1.087-6.26-0.221-8.299,2.167l-15.635,18.317l-15.635-18.317c-2.039-2.389-5.353-3.255-8.299-2.167
                           c-2.947,1.086-4.905,3.895-4.905,7.037v50c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-29.661l8.135,9.53
                           c1.425,1.669,3.509,2.631,5.704,2.631s4.279-0.961,5.704-2.631l8.135-9.53v29.661c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-50
                           C292.195,84.588,290.237,81.78,287.29,80.693z"/>
                         <path d="M361.711,32.448C335.363,11.523,300.434,0,263.355,0c-37.079,0-72.01,11.524-98.356,32.448
                           c-26.854,21.328-41.643,49.839-41.643,80.282c0,53.437,45.967,99.009,110.149,110.165c1.168,16.66-4.858,33.198-16.639,45.091
                           c-2.131,2.151-2.759,5.371-1.594,8.165c1.165,2.793,3.895,4.613,6.922,4.613c34.298,0,63.751-24.484,70.694-57.815
                           c64.351-11.061,110.467-56.692,110.467-110.219C403.356,82.288,388.566,53.776,361.711,32.448z M285.178,208.966
                           c-3.906,0.54-6.728,4.01-6.457,7.944c0.002,0.035,0.005,0.069,0.008,0.104c-3.452,22.079-19.215,39.739-39.588,46.15
                           c7.824-13.859,11.039-30.124,8.82-46.213c0.001-0.015,0.002-0.029,0.003-0.043c0.271-3.933-2.551-7.404-6.456-7.944
                           c-59.77-8.261-103.151-48.733-103.151-96.233c0-53.889,56.074-97.73,124.999-97.73c68.926,0,125.001,43.841,125.001,97.73
                           C388.356,160.239,344.964,200.713,285.178,208.966z"/>
                       </g>
                       </svg>
                        </span>
  

<span class="open-mail" *ngIf="element.type == 2">
  <svg version="1.1" id="MAIL" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 width="15px" height="15px" viewBox="0 0 1800 1800" enable-background="new 0 0 1800 1800" xml:space="preserve">
<g>
	<path fill="#333333" d="M531.087,344.727c0.247,0,0.492,0.033,0.739,0.033h453.558c16.819,0,30.444-13.625,30.444-30.436
		c0-16.815-13.625-30.435-30.444-30.435H638.226H531.826c-16.811,0-30.44,13.62-30.44,30.435
		C501.386,330.885,514.624,344.331,531.087,344.727z"/>
	<path fill="#333333" d="M531.826,497.389h749.422c16.814,0,30.443-13.629,30.443-30.439c0-16.814-13.629-30.439-30.443-30.439
		H531.826c-16.811,0-30.44,13.625-30.44,30.439C501.386,483.76,515.016,497.389,531.826,497.389z"/>
	<path fill="#333333" d="M531.826,650.009h749.422c16.814,0,30.443-13.633,30.443-30.444c0-8.872-3.822-16.827-9.877-22.389
		c-5.424-4.982-12.625-8.046-20.566-8.046H531.826c-7.938,0-15.143,3.064-20.567,8.046c-6.054,5.562-9.873,13.517-9.873,22.389
		C501.386,636.376,515.016,650.009,531.826,650.009z"/>
	<path fill="#333333" d="M1311.691,772.194c0-16.806-13.629-30.436-30.443-30.436H531.826c-16.811,0-30.44,13.629-30.44,30.436
		c0,16.815,13.629,30.444,30.44,30.444h749.422C1298.063,802.638,1311.691,789.009,1311.691,772.194z"/>
	<path fill="#333333" d="M1772.088,533.511c-2.481-3.422-5.691-6.4-9.603-8.622l-246.454-139.961v-82.389v-9.853
		c-1.264-7.738-5.432-14.501-11.406-19.066l-49.465-42.835l-131.073-113.508l-61.889-53.596c-5.286-4.582-11.866-7.021-18.591-7.275
		h-2.197H937.55h-66.904H383.746c-47.809,0-86.705,38.895-86.705,86.696V382.15L61.554,515.893
		c-31.678,11.565-54.396,41.913-54.396,77.54v1067.543c0,45.554,37.064,82.618,82.622,82.618h1625.598
		c45.558,0,82.623-37.064,82.623-82.618V593.433C1798,569.839,1788.002,548.583,1772.088,533.511z M1614.426,510.814l92.579,52.583
		l-11.661,8.301l-179.313,127.664V571.698v-60.883v-55.873L1614.426,510.814z M1405.5,267.454h-132.895V152.361L1405.5,267.454z
		 M357.922,571.698v-60.883v-93.226v-70.01V143.102c0-14.239,11.585-25.825,25.824-25.825h379.699H886.73h34.734h123.285h167.617
		v180.296c0,16.631,13.483,30.11,30.119,30.11h212.674v22.668v70.015v90.448v60.883V742.7l-397.298,282.87l-50.781,36.148
		l-18.591,13.241l-81.088,57.728l-81.093-57.728l-18.611-13.25l-50.782-36.155L357.922,741.483V571.698z M193.76,510.814
		l103.281-58.649v58.649v60.883V698.14L119.448,571.698l-14.597-10.395L193.76,510.814z M68.036,1648.984V609.822l229.005,163.047
		l60.88,43.344L710.7,1067.38l-8.372,7.58l-67.267,60.871L68.036,1648.984z M121.495,1682.723l604.294-546.892l35.693-32.304
		l45.37,32.304l82.897,59.028c5.283,3.76,11.462,5.637,17.653,5.637c6.187,0,12.369-1.877,17.652-5.637l82.889-59.028l45.354-32.286
		l35.686,32.286l604.311,546.892H121.495z M1737.119,1640.271l-557.41-504.439l-67.267-60.871l-8.359-7.563l351.077-249.962
		l60.871-43.348l221.088-157.407V1640.271z"/>
</g>
</svg>
</span>
<span class="push-notification" *ngIf="element.type == 3">
  <svg width="15" height="20" viewBox="0 0 904 1049" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M200.293 1020.72C194.55 1026.13 185.125 1022.06 185.125 1014.17V792.824C185.125 787.853 181.096 783.824 176.125 783.824H34C29.0294 783.824 25 779.794 25 774.824V190C25 185.029 29.0294 181 34 181H870C874.971 181 879 185.029 879 190V774.824C879 779.794 874.971 783.824 870 783.824H455.569C453.277 783.824 451.07 784.699 449.401 786.27L200.293 1020.72Z" stroke="black" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M648.771 460.354L596.031 373.847V251.228C597.906 218.625 590.523 186.156 574.734 157.576C558.945 128.996 535.396 105.47 506.809 89.7203C507.199 84.7014 507.199 79.6598 506.809 74.641C506.501 64.5298 504.205 54.5784 500.052 45.3557C495.899 36.133 489.97 27.8198 482.605 20.8913C475.239 13.9629 466.581 8.55498 457.126 4.97682C447.671 1.39867 437.604 -0.279607 427.5 0.0379415C417.396 -0.279607 407.329 1.39867 397.874 4.97682C388.419 8.55498 379.761 13.9629 372.395 20.8913C365.03 27.8198 359.101 36.133 354.948 45.3557C350.795 54.5784 348.499 64.5298 348.191 74.641C347.608 79.6504 347.608 84.7108 348.191 89.7203C319.604 105.47 296.055 128.996 280.266 157.576C264.477 186.156 257.094 218.625 258.969 251.228V373.847L206.229 460.354C201.667 467.853 199.176 476.429 199.009 485.207C198.842 493.984 201.007 502.649 205.281 510.316C209.555 517.982 215.786 524.377 223.337 528.845C230.889 533.314 239.49 535.697 248.263 535.751H318.451C320.285 563.187 332.668 588.846 353 607.343C373.332 625.84 400.033 635.737 427.5 634.957C454.967 635.737 481.668 625.84 502 607.343C522.332 588.846 534.715 563.187 536.549 535.751H606.737C615.51 535.697 624.111 533.314 631.663 528.845C639.214 524.377 645.445 517.982 649.719 510.316C653.993 502.649 656.158 493.984 655.991 485.207C655.824 476.429 653.333 467.853 648.771 460.354ZM397.759 74.641C398.464 67.4093 401.973 60.742 407.532 56.0685C413.092 51.3951 420.26 49.0877 427.5 49.641C434.74 49.0877 441.908 51.3951 447.468 56.0685C453.027 60.742 456.536 67.4093 457.241 74.641C447.337 74.0203 437.404 74.0203 427.5 74.641C417.596 74.0098 407.663 74.0098 397.759 74.641ZM427.5 585.354C413.171 586.075 399.097 581.373 388.075 572.182C377.054 562.991 369.893 549.985 368.019 535.751H486.981C485.107 549.985 477.946 562.991 466.925 572.182C455.903 581.373 441.829 586.075 427.5 585.354ZM248.263 486.148L301.399 400.037L308.537 387.736V251.228C308.442 221.51 316.686 192.362 332.33 167.101C343.124 152.296 357.559 140.534 374.234 132.956C390.908 125.378 409.257 122.24 427.5 123.847C445.743 122.24 464.092 125.378 480.766 132.956C497.441 140.534 511.876 152.296 522.67 167.101C538.314 192.362 546.558 221.51 546.463 251.228V387.736L553.601 400.037L606.737 486.148H248.263Z" fill="black"/>
    </svg>
    
</span>
<span class="whatsapp" *ngIf="element.type == 5">
  <svg width="15px" height="15px" viewBox="0 0 48 48" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:var(--black-color);stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="cls-1" d="M24,2.5A21.52,21.52,0,0,0,5.15,34.36L2.5,45.5l11.14-2.65A21.5,21.5,0,1,0,24,2.5ZM13.25,12.27h5.86a1,1,0,0,1,1,1,10.4,10.4,0,0,0,.66,3.91,1.93,1.93,0,0,1-.66,2.44l-2.05,2a18.6,18.6,0,0,0,3.52,4.79A18.6,18.6,0,0,0,26.35,30l2-2.05c1-1,1.46-1,2.44-.66a10.4,10.4,0,0,0,3.91.66,1.05,1.05,0,0,1,1,1v5.86a1.05,1.05,0,0,1-1,1,23.68,23.68,0,0,1-15.64-6.84,23.6,23.6,0,0,1-6.84-15.64A1.07,1.07,0,0,1,13.25,12.27Z"/></svg>
</span>
                        </td>
                      </ng-container>
    
                 
    
              
    
                      <ng-container matColumnDef="createdByName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                          CREATED BY
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">
                          {{ element.createdByName }}
                           
                        </td>
                      </ng-container>
    
                      <ng-container matColumnDef="createdDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                         CREATED DATE
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">
                         {{moment(element?.createdDate).format('DD-MM-YYYY HH:mm:ss')}}
                        
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="modifiedByName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                         MODIFIED BY
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">
                          {{ element.modifiedByName || '--' }}
                         
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="modifiedDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                          MODIFIED DATE
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">
                          {{element?.modifiedDate ? moment(element?.modifiedDate).format('DD-MM-YYYY HH:mm:ss') : '--'  }}
                        </td>
                      </ng-container>
                
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="" mat-sort-header style="min-width: 85px">
                          ACTION
                        </th>
                        <td mat-cell *matCellDef="let element" class="" style="min-width: 85px">

                          <svg (click)="Edittemplate(element?.id,'edit');" width="40" height="24" viewBox="0 0 24 24" fill="var(--shade-of-green)"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M4.5 17.2071V19C4.5 19.2761 4.72386 19.5 5 19.5H6.79289C6.9255 19.5 7.05268 19.4473 7.14645 19.3536L15.6452 10.8548L13.1452 8.35485L4.64645 16.8536C4.55268 16.9473 4.5 17.0745 4.5 17.2071Z"
                              stroke="#5ce61b" />
                          <path
                              d="M15.0897 6.4103L17.5897 8.9103L18.7929 7.70711C19.1834 7.31658 19.1834 6.68342 18.7929 6.2929L17.7071 5.20711C17.3166 4.81658 16.6834 4.81658 16.2929 5.20711L15.0897 6.4103Z"
                              stroke="#5ce61b" />
                      </svg>
                      <!-- <svg (click)="deleteiconDialog(element?.id)" fill="#ff3131" width="35" height="18" viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M22,5H17V2a1,1,0,0,0-1-1H8A1,1,0,0,0,7,2V5H2A1,1,0,0,0,2,7H3.117L5.008,22.124A1,1,0,0,0,6,23H18a1,1,0,0,0,.992-.876L20.883,7H22a1,1,0,0,0,0-2ZM9,3h6V5H9Zm8.117,18H6.883L5.133,7H18.867Z" />
                      </svg> -->
                        </td>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer">
                      </tr>
                </table>
                <mat-paginator #paginator [pageSize]="pageSize" [pageIndex]="pageIndex" class="calling-list-pagenation calling-list-pagenation"
  [pageSizeOptions]="pageSizeOptions" (page)="openpage($event)" showFirstLastButtons  aria-label="Select page"></mat-paginator>
  <ng-container *ngIf="loadingData" >
    <!-- <div *ngIf="loadingData" class="loader">Loading...</div> -->
     <div class="loader">
      <mat-spinner diameter="40" color="accent"></mat-spinner>
      <div>Loading...</div>
     </div>
    
  </ng-container>
            </div>
        </div>
    </div>
    <app-footer></app-footer>

</mat-drawer-container>